export default __webpack_public_path__ + "static/media/size-chart.ff9f6ed3.pdf";